import React, { Component } from 'react';
import { connect } from 'react-redux';

import { HashLink as Link } from 'react-router-hash-link';
import { Panel } from 'react-bootstrap';
import axios from '../../../../services/axios-service';
import AWS from 'aws-sdk';

import './PrintCandidateProfile.css';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';

import CandidateOverview from '../../CandidateOverview/CandidateOverview';
import config from '../../../../config';
import RecruiterComments from '../../RecruiterComments/RecruiterComments';
import Experience from '../../Experience/Experience';
import Skills from '../../Skills/skills';
import Languages from '../../Languages/Languages';
import Education from '../../Education/Education';
import Hobby from '../../Hobby/Hobby';
import printIcon from '../../../../assets/images/icon-sm-printer.png';
import './printCandidatePreview.css';

const noDataString = "- Not Specified -";

/**
* @desc Print candidate Profile
* @version 1.0.1
* @author Amrutha K K , Lakshmikanth
*/
class PrintCandidateProfile extends Component {
  
  state = {
    candidatePhoto : null
  }  
  
  getS3ImageUrl = (imageUrl) => {
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3();
    return new Promise(function(resolve, reject) {
      S3.getSignedUrl('getObject', { Bucket: config.cognito.bucketName , Key: imageUrl}, function(err, data) {
        if (err) {
          localStorage.removeItem("candidatePhoto"); 
          reject(err);
        } else {        
          localStorage.setItem("candidatePhoto", data);   
          resolve(data);
        }
      });
    });
  }
  /**
   * @desc redeux call to get the candidate  image on loading
   * @param null
   * @return null
   */
  componentDidMount() {  
      if(this.props.profileInfo.candidatePhoto === null) {
        this.setState({ candidatePhoto: null });
      } else {
        this.getS3ImageUrl(this.props.profileInfo.candidatePhoto)
          .then((url) => { 
            this.setState({ candidatePhoto: url });
          });
      }
  }

  render() {
    const candidate_id = (this.props.match && this.props.match.params.id) ? this.props.match.params.id : this.props.candidate_id;
    const candidate = this.props.profileInfo;
    if(!candidate || candidate.length === 0) {
      return (<div>Loading...</div>);
    }
    const backProfile=<Link className='back-profile' to="/">Back to Profile</Link>

    return (
      <div className="print-profile">
        <div className="row ">
          <div className="col-md-3 back-profile-arrow">{'<< '}{backProfile}</div>
          <h1 className="cvHead col-md-7">CURRICULUM VITAE</h1>
          <div className="col-md-2">
            <button 
              className="print-btn"
              type="button" 
              onClick={()=>window.print() }
            >
              <span className="icon-print">
                <img src={printIcon}/>
              </span>Print
            </button>
          </div>
        </div>
        <div id="print-preview">
          <Panel className="print-panel profile-tabs">
            <Panel.Body>
              <CandidateOverview 
                {...this.props} 
                candidate={candidate} 
                candidate_id={candidate_id} 
                candidate_status={this.state.candidate_status} 
                onPoolStatusChange={this.props.onPoolStatusChange}
                jobTitleId = {this.props.jobTitleId}
                open={this.open}
                user={this.props.user}
                attributes={this.props.attributes}
                isPrint={true}
                candidatePhoto={this.state.candidatePhoto}
                isS3Url={(this.state.candidatePhoto !== null ) ? true : false }
              />                      
            </Panel.Body>                    
          </Panel>

          <Panel className="print-panel panel-recruiter">
            <Panel.Heading className="recruiter">
              <Panel.Title >Recruiter's Comments</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                {(candidate.recruiter_comments) ? candidate.recruiter_comments.split('\n').map((comments, index) => (
                  <RecruiterComments key={index} text={comments} />
                )) : <p className="no-data">{noDataString}</p> }                        
              </div>
            </Panel.Body>         
          </Panel>

          <Panel className="print-panel panel-experience">
            <Panel.Heading className="experience">
              <Panel.Title >Experience</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                {(candidate.experience.length > 0) ? candidate.experience.map((exp, index) => (
                  <Experience key={index} {...exp} />
                )): <p className="no-data">{noDataString}</p>}
              </div>
            </Panel.Body>         
          </Panel>
          
          <Panel className="print-panel panel-skills">
            <Panel.Heading className="skills">
              <Panel.Title > Skills</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                { (candidate.skills.length > 0 ) ? candidate.skills.map((skill, index) => (
                  <Skills key={index} skill={skill} />
                )) : <p className="no-data">{noDataString}</p>}
              </div>
            </Panel.Body>         
          </Panel>
          
          <Panel className="print-panel panel-education">
            <Panel.Heading className="education">
              <Panel.Title >Education</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                { (candidate.education.filter((edu) => { return edu.isTraining == 0; }).length > 0) ? candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                      <Education key={index} {...edu} />
                    )) : <p className="no-data">{noDataString}</p> }
              </div>
            </Panel.Body>         
          </Panel>

          <Panel className="print-panel panel-training">
            <Panel.Heading className="training">
              <Panel.Title >Training</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                { (candidate.education.filter((edu) => { return edu.isTraining == 1; }).length > 0) ?candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                  <Education key={index} {...train} />
                )) : <p className="no-data">{noDataString}</p>}
              </div>
            </Panel.Body>         
          </Panel>
          <Panel className="print-panel">
            <Panel.Heading className="languages">
              <Panel.Title >Languages</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                {(candidate.languages.length > 0 ) ? candidate.languages.map((lang, index) => (
                  <Languages key={index} {...lang} />
                )) : <p className="no-data">{noDataString}</p> }
              </div>
            </Panel.Body>         
          </Panel>

          <Panel className="print-panel">
            <Panel.Heading className="hobbies">
              <Panel.Title > Hobbies </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div className="show-grid">
                { (candidate.hobbies.length > 0) ?  candidate.hobbies.map((hobby, index) => (
                  <Hobby key={index} hobby={hobby} />
                )) :<p className="no-data">{noDataString}</p>}
              </div>
            </Panel.Body>         
          </Panel>
        </div>
      </div>
    );
  }
}
/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => {
  return {
    profileInfo: state.candidateProfile.profileInfo,
    user: state.cognito.user,
    attributes: state.cognito.attributes 
  };
} 

export default connect(mapStateToProps,null)(withErrorHandler(PrintCandidateProfile,axios));




// WEBPACK FOOTER //
// ./src/components/Client/CandidateProfilePage/PrintCandidateProfile/PrintCandidateProfile.js